import { render, staticRenderFns } from "./solicitacaoIdenizatoriaForm.vue?vue&type=template&id=3dcad190&scoped=true&"
import script from "./solicitacaoIdenizatoriaForm.vue?vue&type=script&lang=js&"
export * from "./solicitacaoIdenizatoriaForm.vue?vue&type=script&lang=js&"
import style0 from "./solicitacaoIdenizatoriaForm.vue?vue&type=style&index=0&id=3dcad190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcad190",
  null
  
)

export default component.exports